import { Box, Button, Flex, Input, Text } from "@chakra-ui/react";
import { Modal, Select } from "antd";
import moment from "moment-timezone";
import React from "react";
import { AdminAPI } from "../../../Apis/adminAPI";

// Claude: extracted from Buyer.tsx 23-03-2026
interface Props {
  isOpen: boolean;
  onClose: () => void;
  overrideNotes: { reason: string; status: string; timestamp: string }[];
  overrideBuyerId: string;
  overrideStatus: string;
  setOverrideStatus: (v: string) => void;
  overrideReason: string;
  setOverrideReason: (v: string) => void;
  domainConflictEmail: string | null;
  setDomainConflictEmail: (v: string | null) => void;
  overrideCurrentStatus: string;
  onConfirm: () => void;
}

const BuyerOverrideModal = ({
  isOpen, onClose, overrideNotes, overrideBuyerId,
  overrideStatus, setOverrideStatus, overrideReason, setOverrideReason,
  domainConflictEmail, setDomainConflictEmail, overrideCurrentStatus, onConfirm,
}: Props) => (
  <Modal
    title="Override Verification Status"
    footer={null}
    open={isOpen}
    onCancel={onClose}
    bodyStyle={{ maxHeight: "70vh", overflowY: "auto" }}
  >
    <Box p={2}>
      {overrideNotes.length > 0 && (
        <Box mb={4} p={3} bg="gray.50" borderRadius="md" borderWidth="1px" borderColor="gray.200">
          <Text fontSize="xs" fontWeight="600" color="gray.500" mb={2} textTransform="uppercase">Previous overrides</Text>
          {overrideNotes.map((note, i) => (
            <Text key={i} fontSize="xs" color="gray.600" mb={i < overrideNotes.length - 1 ? 1 : 0}>
              {moment(note.timestamp).format("DD MMM YYYY, HH:mm")}: Changed from{" "}
              <b>{overrideNotes[i + 1]?.status ?? "unverified"}</b> to <b>{note.status}</b>. Note: {note.reason}
            </Text>
          ))}
        </Box>
      )}
      <Text mb={2} fontSize="sm">New status:</Text>
      <Select
        style={{ width: "100%", marginBottom: 12 }}
        placeholder="Select status"
        value={overrideStatus || undefined}
        onChange={async (val: string) => {
          setOverrideStatus(val);
          if (val === "verified") {
            try {
              const res = await AdminAPI.checkBuyerDomainConflict(overrideBuyerId);
              setDomainConflictEmail(res?.conflict ? res.conflictEmail : null);
            } catch { setDomainConflictEmail(null); }
          } else {
            setDomainConflictEmail(null);
          }
        }}
        options={[
          { label: "Verified", value: "verified" },
          { label: "Provisional", value: "provisional" },
          { label: "Blocked", value: "blocked" },
          { label: "Inactive", value: "inactive" },
        ]}
      />
      {domainConflictEmail && (
        <Text fontSize="sm" color="red.600" bg="red.50" p={2} borderRadius="md" mb={3}>
          Cannot set as Verified as another verified user exists with the same domain.
        </Text>
      )}
      {/* Claude: set-password email notice — shown when approving a pendingNewUser account 23-03-2026 */}
      {overrideCurrentStatus === "pendingNewUser" && (overrideStatus === "verified" || overrideStatus === "provisional") && (
        <Text fontSize="sm" color="blue.700" bg="blue.50" p={2} borderRadius="md" mb={3}>
          A set-password email will be automatically sent to this user upon confirmation.
        </Text>
      )}
      <Text mb={2} fontSize="sm">Reason (required):</Text>
      <Input
        placeholder="Enter reason for override"
        value={overrideReason}
        onChange={(e) => setOverrideReason(e.target.value)}
        mb={4}
      />
      <Flex justifyContent="flex-end" gap={2}>
        <Button variant="outline" onClick={() => { onClose(); setDomainConflictEmail(null); }}>
          Cancel
        </Button>
        <Button background="#0E122F" color="white" px={4} py={2} h="auto"
          _hover={{ background: "#2E7D32" }} onClick={onConfirm} isDisabled={!!domainConflictEmail}
        >
          Confirm
        </Button>
      </Flex>
    </Box>
  </Modal>
);

export default BuyerOverrideModal;
